import {
  Box,
  Flex,
  Grid,
  Skeleton,
  SkeletonCircle,
  Stack,
  Text,
} from "@chakra-ui/react";
import * as React from "react";

import IconShoppingBag from "components/Chakra/Icons/ShoppingBag";
import IconTram from "components/Chakra/Icons/Tram";
import { useDetailState } from "scenes/OfferDetail";
import { IMarginProps } from "src/types/types";

const Neighborhood: React.FC<IMarginProps> = ({ ...margins }) => {
  const { offer, isLoaded } = useDetailState();

  if (!isLoaded) {
    return (
      <Grid
        templateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)"]}
        my="42px"
        gap={5}
      >
        <Stack>
          <Stack direction="row" align="center" spacing={1}>
            <SkeletonCircle boxSize="20px" />
            <Skeleton w="300px" h="15px" />
          </Stack>
          <Stack direction="row" align="center" spacing={1}>
            <SkeletonCircle boxSize="20px" />
            <Skeleton w="300px" h="15px" />
          </Stack>
        </Stack>
        <Stack>
          <Stack direction="row" align="center" spacing={1}>
            <SkeletonCircle boxSize="20px" />
            <Skeleton w="300px" h="15px" />
          </Stack>
          <Stack direction="row" align="center" spacing={1}>
            <SkeletonCircle boxSize="20px" />
            <Skeleton w="300px" h="15px" />
          </Stack>
        </Stack>
      </Grid>
    );
  }

  return (
    <Grid
      templateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)"]}
      gap={5}
      {...margins}
    >
      <Box>
        {offer?.nearby?.map((item) => {
          if (item.type === "mall") {
            return (
              <Flex
                key={item.name}
                align="center"
                data-test="offerDetail.neighborhood.shops"
              >
                <SkeletonCircle isLoaded={isLoaded}>
                  <IconShoppingBag mr="5px" boxSize="20px" />
                </SkeletonCircle>
                <Skeleton isLoaded={isLoaded}>
                  <Text textAlign="left">
                    {item.name} - 6 minut (mhd)
                    {/* {item.value} */}
                  </Text>
                </Skeleton>
              </Flex>
            );
          }
        })}
      </Box>
      <Stack mt={["20px", "0px"]} spacing="20px">
        {offer?.nearby?.map((item) => {
          if (item.type !== "mall") {
            return (
              <Flex
                key={item.name}
                align="center"
                data-test="offerDetail.neighborhood.transit"
              >
                <SkeletonCircle isLoaded={isLoaded}>
                  <IconTram mr="5px" boxSize="20px" />
                </SkeletonCircle>
                <Skeleton isLoaded={isLoaded}>
                  <Text textAlign="left">
                    {item.name} - 6 minut (mhd)
                    {/* {item.value} */}
                  </Text>
                </Skeleton>
              </Flex>
            );
          }
        })}
      </Stack>
    </Grid>
  );
};

export default Neighborhood;
